import AlarmIcon from '../assets/icons/alarm.svg?react';
import ChannelsIcon from '../assets/icons/channels.svg?react';
import MachineIcon from '../assets/icons/machine.svg?react';
import NotificationIcon from '../assets/icons/notification.svg?react';
import SwapVertIcon from '../assets/icons/swap_vert.svg?react';
import { useMobileSidebar } from '../contexts/MobileSidebarContext';
import { NavigationItem } from './NavigationItem';

export function Navigation() {
  const { close } = useMobileSidebar();

  return (
    <nav>
      <ul>
        <NavigationItem
          route='/machines'
          title='Machines'
          icon={<MachineIcon />}
          onClick={close}
        />
        <NavigationItem
          route='/alarms'
          title='Pulse alerts'
          icon={<AlarmIcon />}
          onClick={close}
        />
        <NavigationItem
          route='/channels'
          title='Channels'
          icon={<ChannelsIcon />}
          onClick={close}
        />
        <NavigationItem
          route='/notification-history'
          title='Notifications'
          icon={<NotificationIcon />}
          onClick={close}
        />
        <NavigationItem
          route='/edms-explorer'
          title='EDMS API'
          icon={<SwapVertIcon />}
          onClick={close}
        />
      </ul>
    </nav>
  );
}
